export const QUESTIONS = [
    {
        id: 'drink', tag: '양가감정', title: '하루 끝의 한 잔', person: '퇴근 후 술로 스트레스를 푸는 직장인',
        quote: '술을 줄여야 하는 건 아는데, 퇴근 후에 술이라도 없으면 너무 답답해요.',
        prompt: '변화하고 싶은 마음과 지금의 행동을 유지하고 싶은 마음을 함께 담아보세요.',
        options: [
            { text: '건강을 생각해서 술 대신 운동을 시작해보세요.', score: 0, type: '조언', feedback: '해결책을 먼저 제안하고 있어요. 지금은 술이 이 사람에게 어떤 의미인지 되돌려주는 연습입니다.' },
            { text: '퇴근 후 술을 마시면 답답함이 좀 풀리시는군요.', score: 60, type: '단순반영', feedback: '술의 역할을 정확히 되짚었어요. 여기에 술을 줄여야 한다는 마음까지 담으면 양쪽 마음을 함께 반영할 수 있어요.' },
            { text: '술이 답답함을 풀어주지만, 한편으로는 줄일 필요도 느끼시는군요.', score: 100, type: '양면반영', feedback: '술이 주는 도움과 줄이고 싶은 마음을 함께 담았어요. 어느 한쪽을 판단하거나 결론을 강요하지 않은 점이 좋아요.' },
            { text: '술 없이 스트레스를 풀어본 적은 없으세요?', score: 20, type: '질문', feedback: '탐색에 쓸 수 있는 질문이지만 반영 문장은 아니에요. 물어보기 전에 이미 들은 마음을 먼저 되돌려주세요.' },
        ],
        example: '술이 하루를 버티게 해주는 위안이면서도, 계속 이렇게 마시는 건 걱정되시는군요.',
        checklist: ['술이 답답함을 풀어준다는 의미를 담았나요?', '줄일 필요를 느끼는 마음도 함께 담았나요?', '해결책을 권하거나 질문하기보다 이해한 마음을 표현했나요?'],
    },
    {
        id: 'study', tag: '감정 반영', title: '책을 펼치기 어려운 날', person: '시험 준비를 미루고 있는 대학생',
        quote: '공부해야 하는데 책만 펴면 막막해요. 또 못할 것 같아서 자꾸 미루게 돼요.',
        prompt: '미루는 행동 너머에 있는 두려움을, 단정하지 않는 말로 담아보세요.',
        options: [
            { text: '또 잘 안 될까 봐 두려워서 시작하는 것부터 부담스러우신 것 같아요.', score: 100, type: '복합반영', feedback: '막막함과 실패에 대한 걱정을 연결했어요. “것 같아요”라는 표현으로 내담자가 이해를 수정할 여지도 남겼어요.' },
            { text: '공부를 자꾸 미루고 계시는군요.', score: 60, type: '단순반영', feedback: '행동을 정확히 반영했어요. 실패할까 봐 두려운 마음까지 담으면 더 깊은 이해를 표현할 수 있어요.' },
            { text: '매일 30분씩만 공부하면 괜찮아질 거예요.', score: 0, type: '조언·안심', feedback: '아직 확인하지 않은 해결책과 결과를 제시했어요. 먼저 시작이 어려운 마음을 이해해보세요.' },
            { text: '왜 그렇게 의지가 부족하다고 생각하세요?', score: 0, type: '판단이 담긴 질문', feedback: '내담자가 말하지 않은 “의지 부족”을 전제하고 있어요. 실패에 대한 걱정을 비난 없이 반영해보세요.' },
        ],
        example: '잘하고 싶은데 다시 못할까 봐 걱정돼서, 책을 펴는 일도 무겁게 느껴지시는 것 같아요.',
        checklist: ['막막함이나 실패에 대한 걱정을 담았나요?', '미루는 행동을 의지 부족으로 판단하지 않았나요?', '추측을 사실처럼 단정하지 않았나요?'],
    },
    {
        id: 'exercise', tag: '의미 반영', title: '다시 시작하는 망설임', person: '운동을 여러 번 시작했다가 그만둔 성인',
        quote: '운동하면 좋겠죠. 그런데 매번 며칠 하다가 그만두니까, 이번에도 똑같을 것 같아요.',
        prompt: '운동의 필요성을 설득하기보다, 다시 시도하기 어려운 이유를 반영해보세요.',
        options: [
            { text: '이번에는 꼭 할 수 있어요. 자신감을 가지세요.', score: 0, type: '근거 없는 안심', feedback: '응원하려는 마음은 있지만 반복된 중단 경험을 충분히 다루지 못했어요. 망설임의 이유를 먼저 반영해보세요.' },
            { text: '어떤 운동을 해보셨나요?', score: 20, type: '질문', feedback: '정보를 알아보는 질문이에요. 이 문제에서는 다시 중단할 것 같은 걱정을 반영하는 데 집중해보세요.' },
            { text: '운동을 며칠 하다가 그만두셨군요.', score: 60, type: '단순반영', feedback: '이전 경험을 정확히 되짚었어요. 그 경험 때문에 다시 시도하기 어렵다는 의미도 담아볼 수 있어요.' },
            { text: '운동이 좋다는 건 알지만, 또 중간에 그만두게 될까 봐 시작이 망설여지시는군요.', score: 100, type: '복합반영', feedback: '과거의 경험과 현재의 망설임을 연결했어요. 운동을 해야 한다고 설득하지 않고 내담자의 관점에서 이해했어요.' },
        ],
        example: '해보고 싶은 마음도 있지만, 예전처럼 이어가지 못할까 봐 다시 시작하기가 조심스러우시군요.',
        checklist: ['반복해서 중단했던 경험을 이해했나요?', '다시 시작하기 망설여지는 마음을 담았나요?', '성공을 장담하거나 운동을 강요하지 않았나요?'],
    },
];

export const STORAGE_KEY = 'garam-reflection-practice-v1';
export const monthKey = (date = new Date()) => new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit' }).format(date);
export function validRecords(value) {
    if (!Array.isArray(value)) return [];
    return value.filter(r => r && /^\d{4}-\d{2}$/.test(r.month) && QUESTIONS.some(q => q.id === r.questionId && Number.isInteger(r.choice) && q.options[r.choice]?.score === r.score)).slice(-120);
}
export function recordAnswer(records, question, choice, month) {
    if (!question.options[choice] || records.some(r => r.month === month && r.questionId === question.id)) return records;
    return [...records, { month, questionId: question.id, choice, score: question.options[choice].score }].slice(-120);
}
export function leaderboard(records, month) {
    const own = records.filter(r => r.month === month);
    const samples = Array.from({ length: 30 }, (_, i) => ({ id: `sample-${i}`, name: `연습생 ${String(i + 1).padStart(2, '0')}`, score: Math.max(0, 300 - i * 10), sample: true }));
    if (own.length) samples.push({ id: 'me', name: '나 (이 브라우저)', score: own.reduce((sum, r) => sum + r.score, 0), sample: false });
    return samples.sort((a, b) => b.score - a.score || a.id.localeCompare(b.id)).map((r, i, all) => ({ ...r, rank: all.findIndex(other => other.score === r.score) + 1 }));
}
